<template>
  <div class="d-flex-row space-between">
    <ClientOnly>
      <p
        class="t-grey font-family-2 regular-l d-flex-row justify-start height-max-content"
        v-html="fromTo"
      ></p>
    </ClientOnly>
    <!-- DONT ADD PRICE HERE -->
  </div>
  <div class="d-flex-row space-between" v-if="checkoutStore.getDetails.league">
    <p class="t-grey font-family-2 regular-l">
      {{ $t("league_2v2") }}
    </p>
    <p class="t-white font-family-2 f-w-700 regular-l">
      {{ checkoutStore.getDetails.league }}
    </p>
  </div>
  <!-- GEAR TYPE POE -->
  <div class="d-flex-row space-between" v-if="checkoutStore.getDetails.coins">
    <p class="t-grey font-family-2 regular-l">
      {{ $t("main.nav.coins") }}
    </p>
    <p class="t-white font-family-2 f-w-700 regular-l">
      {{ checkoutStore.getDetails.coins }}
    </p>
  </div>
  <div class="d-flex-row space-between" v-if="checkoutStore.getDetails.gearId">
    <p class="t-grey font-family-2 regular-l">
      {{ $t("path_of_exile.gear_type") }}
    </p>
    <p class="t-white font-family-2 f-w-700 regular-l">
      {{ checkoutStore.getDetails.gearTitle }}
    </p>
  </div>

  <div
    class="d-flex-row space-between align-start"
    v-if="checkoutStore.getDetails.trials"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("path_of_exile.trials2") }}
    </p>
    <div class="d-flex-column justify-end align-end flex-7">
      <p
        class="t-white font-family-2 f-w-700 regular-l"
        v-for="trial in checkoutStore.getDetails?.trials"
      >
        {{ trial.title }}
      </p>
    </div>
  </div>

  <div
    class="d-flex-row space-between align-start"
    v-if="checkoutStore.getDetails.acts"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("path_of_exile.campaign_acts") }}
    </p>
    <div class="d-flex-column justify-end align-end flex-7">
      <p
        class="t-white font-family-2 f-w-700 regular-l"
        v-for="trial in checkoutStore.getDetails?.acts"
      >
        {{ trial.title }}
      </p>
    </div>
  </div>

  <div
    class="d-flex-row space-between"
    v-if="checkoutStore.getSelectedRaid?.id"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("new.checkout.role") }}
    </p>
    <p class="t-white font-family-2 f-w-700 regular-l">
      {{ checkoutStore.getSelectedRaid.title }}
    </p>
    <!-- DONT ADD PRICE HERE -->
  </div>

  <div
    class="d-flex-column justify-start align-start gap-9"
    v-if="
      checkoutStore.getDetails.difficultyTitle &&
      checkoutStore.getDetails.numberOfWins
    "
  >
    <div class="d-flex-row space-between">
      <p class="t-grey font-family-2 regular-l">
        {{ $t("new.difficulty") }}
      </p>
      <p class="t-white font-family-2 regular-l">
        {{ checkoutStore.getDetails.difficultyTitle }}
      </p>
    </div>
    <div class="d-flex-row space-between">
      <div class="d-flex-row space-between">
        <p class="t-grey font-family-2 regular-l">
          {{ $t("order.card.numberOfWins") }}
        </p>
        <p class="t-white font-family-2 regular-l">
          {{ checkoutStore.getDetails.numberOfWins }}
        </p>
      </div>
    </div>
  </div>

  <div
    class="d-flex-column justify-start align-start gap-9"
    v-if="
      checkoutStore.getDetails.objectiveTitle &&
      checkoutStore.getDetails.numberOfObjectives
    "
  >
    <div class="d-flex-row space-between">
      <div class="d-flex-row space-between">
        <p class="t-grey font-family-2 regular-l">
          {{ checkoutStore.getDetails.objectiveTitle }}
        </p>
        <p class="t-white font-family-2 regular-l">
          {{ checkoutStore.getDetails.numberOfObjectives }}
        </p>
      </div>
    </div>
  </div>

  <div
    class="d-flex-row space-between align-start"
    v-if="checkoutStore.getDetails.optionSlabs"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("fc-boost.divisions") }}
    </p>
    <div class="d-flex-column flex-5 justify-end align-end">
      <p
        class="t-white font-family-2 f-w-500 regular-l"
        v-for="slab in parsedSlabs"
      >
        <!-- test -->
        {{ slab.title }}
      </p>
    </div>
  </div>

  <div
    class="d-flex-column justify-start align-start gap-9"
    v-if="checkoutStore.getDetails.currentDrive >= 0"
  >
    <div
      class="d-flex-row space-between align-start"
      v-if="checkoutStore.getDetails.currentDrive >= 0"
    >
      <p class="t-grey font-family-2 regular-l">
        {{ $t("current_drive") }}
      </p>
      <p class="t-white font-family-2 f-w-500 regular-l">
        {{ checkoutStore.getDetails.currentDrive }}
      </p>
    </div>

    <div
      class="d-flex-row space-between align-start"
      v-if="checkoutStore.getDetails.desiredDrive"
    >
      <p class="t-grey font-family-2 regular-l">
        {{ $t("desired_drive") }}
      </p>
      <p class="t-white font-family-2 f-w-500 regular-l">
        {{ checkoutStore.getDetails.desiredDrive }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    basePrice: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    fromTo() {
      let from = "";
      let to = "";

      if (
        this.checkoutStore.getDetails.currentRankSlab &&
        this.checkoutStore.getDetails.currentRankTitle
      ) {
        return `<div class='d-flex-column justify-start align-start gap-5 height-max-content'>
            <div class='d-flex-row space-between height-max-content'>
              ${this.$t(
                "calculators_common.current_rank"
              )} <span class='t-white'>${
          this.checkoutStore.getDetails?.currentRankTitle
        }</span>
            </div>
                      <div class='d-flex-row space-between height-max-content'>
              ${this.$t(
                "calculators_common.desired_rank"
              )} <span class='t-white'>${
          this.checkoutStore.getDetails?.desiredRankTitle
        }</span>
            </div>
          </div>`;
      }

      if (
        (this.checkoutStore.getDetails?.currentRank &&
          this.checkoutStore.getDetails?.desiredRank) ||
        (["Master", "Immortal"].includes(
          this.checkoutStore.getDetails?.currentRankTitle
        ) &&
          !this.checkoutStore.getDetails?.numberOfBoosters &&
          !this.checkoutStore.getDetails.numberOfHours &&
          !this.checkoutStore.getDetails.numberOfGames &&
          !this.checkoutStore.getDetails.numberOfWins)
      ) {
        const fromRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.currentRank
        );
        const toRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.desiredRank
        );

        if (!toRank) {
          return `${fromRank.title}`;
        }
        if (!fromRank || !toRank) {
          return "";
        }

        const fromDivision = fromRank.divisions.find(
          (division) =>
            division.id === this.checkoutStore.getDetails.currentDivision
        );
        const toDivision = toRank?.divisions.find(
          (division) =>
            division.id === this.checkoutStore.getDetails.desiredDivision
        );
        if (
          toRank.title === "Champion" &&
          this.checkoutStore.getCartGame === 3
        ) {
          from = fromDivision
            ? `${fromRank.title} ${fromDivision.title}`
            : `${fromRank.title}`;
          to = `${toRank.title}`;

          return `${from} > ${to}`;
        }
        if (toRank.title === "Supersonic") {
          from = fromDivision
            ? `${fromRank.title} ${fromDivision.title}`
            : `${fromRank.title}`;
          to = `${toRank.title}`;

          return `${from} > ${to}`;
        }

        if (!fromDivision) {
          from = `${fromRank.title}`;
          to = `${toRank.title}`;

          return `${from} > ${to}`;
        }

        from = fromDivision
          ? `${fromRank.title} ${fromDivision.title}`
          : `${fromRank.title}`;
        to = toDivision
          ? `${toRank.title} ${toDivision?.title}`
          : `${toRank.title}`;
        return `${from} > ${to}`;
      } else if (
        this.checkoutStore.getDetails?.currentRank &&
        this.checkoutStore.getDetails?.numberOfGames
      ) {
        const fromRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.currentRank
        );

        const fromDivision = fromRank?.divisions?.find(
          (division) =>
            division.id === this.checkoutStore.getDetails.currentDivision
        );

        if (fromDivision) {
          return `${fromRank?.title} ${fromDivision.title} - ${
            this.checkoutStore.getDetails?.numberOfGames
          } ${this.$t("checkout.games")}`;
        } else {
          return `${fromRank?.title} - ${
            this.checkoutStore.getDetails?.numberOfGames
          } ${this.$t("checkout.games")}`;
        }
      } else if (
        this.checkoutStore.getDetails?.currentRank &&
        this.checkoutStore.getDetails?.numberOfWins
      ) {
        const fromRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.currentRank
        );
        const fromDivision = fromRank?.divisions?.find(
          (division) =>
            division.id === this.checkoutStore.getDetails.currentDivision
        );
        if (fromDivision) {
          return `${fromRank?.title} ${fromDivision.title} - ${
            this.checkoutStore.getDetails?.numberOfWins
          } ${this.$t("checkout.wins")}`;
        } else {
          return `${fromRank?.title} - ${
            this.checkoutStore.getDetails?.numberOfWins
          } ${this.$t("checkout.wins")}`;
        }
      } else if (
        this.checkoutStore.getDetails?.currentRank &&
        this.checkoutStore.getDetails?.rankFrom &&
        this.checkoutStore.getDetails?.desiredRank &&
        this.checkoutStore.getDetails?.rankTo
      ) {
        const fromRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.currentRank
        );
        const toRank = this.getGameRanks.find(
          (gameRank) =>
            gameRank.id === this.checkoutStore.getDetails?.desiredRank
        );

        from = `${fromRank?.title} ${this.checkoutStore.getDetails?.rankFrom}`;
        to = `${toRank?.title} ${this.checkoutStore.getDetails?.rankTo}`;

        return `${from} > ${to}`;
      } else if (
        this.checkoutStore.getDetails?.numberOfGames &&
        this.checkoutStore.getDetails?.numberOfBoosters
      ) {
        return `${this.checkoutStore.getDetails?.numberOfGames} ${this.$t(
          "checkout.games"
        )} - ${this.checkoutStore.getDetails?.numberOfBoosters} ${this.$t(
          "checkout.boosters"
        )}`;
      } else if (this.checkoutStore.getDetails?.soulFighterRankTitle) {
        return `${this.checkoutStore.getDetails?.numberOfGames} ${this.$t(
          "checkout.games"
        )} - ${this.checkoutStore.getDetails.soulFighterRankTitle}`;
      } else if (
        this.checkoutStore.getDetails?.currentMasteryTitle &&
        this.checkoutStore.getDetails?.desiredMasteryTitle
      ) {
        return `${this.checkoutStore.getDetails?.currentMasteryTitle} > ${this.checkoutStore.getDetails?.desiredMasteryTitle}`;
      } else if (
        this.checkoutStore.getDetails?.elearningTitle &&
        this.checkoutStore.getDetails?.numberOfGames
      ) {
        return `${this.checkoutStore.getDetails?.elearningTitle} (x${this.checkoutStore.getDetails?.numberOfGames})`;
      } else if (
        this.checkoutStore.getDetails?.elearningTitle &&
        this.checkoutStore.getDetails?.numberOfHours
      ) {
        return `${this.checkoutStore.getDetails?.elearningTitle} (x${this.checkoutStore.getDetails?.numberOfHours})`;
      } else if (
        this.checkoutStore.getDetails?.elearningTitle &&
        this.checkoutStore.getDetails?.vodReviews
      ) {
        return `${this.checkoutStore.getDetails?.elearningTitle} (x${this.checkoutStore.getDetails?.vodReviews})`;
      } else if (
        this.checkoutStore.getDetails?.faceitCurrentDivision &&
        this.checkoutStore.getDetails?.faceitDesiredDivision
      ) {
        return `${this.checkoutStore.getDetails?.currentDivisionTitle} > ${this.checkoutStore.getDetails?.desiredDivisionTitle}`;
      } else if (
        this.checkoutStore.getDetails?.faceitCurrentDivision &&
        this.checkoutStore.getDetails?.numberOfWins
      ) {
        return `${this.checkoutStore.getDetails?.currentDivisionTitle} - ${
          this.checkoutStore.getDetails?.numberOfWins
        } ${this.$t("checkout.wins")}`;
      } else if (this.checkoutStore.getDetails?.numberOfGames) {
        return `${this.checkoutStore.getDetails?.numberOfGames} ${this.$t(
          "checkout.games"
        )}`;
      } else if (this.checkoutStore.getDetails?.numberOfRounds) {
        return `${this.checkoutStore.getDetails?.numberOfRounds} ${this.$t(
          "others.rounds"
        )}`;
      } else if (this.checkoutStore.getDetails?.currentRankTitle) {
        return `${this.checkoutStore.getDetails?.currentRankTitle}`;
      } else if (
        this.checkoutStore.getDetails?.currentMmr &&
        this.checkoutStore.getDetails?.desiredMmr
      ) {
        return `${this.checkoutStore.getDetails?.currentMmr} > ${this.checkoutStore.getDetails?.desiredMmr}`;
      } else if (
        this.checkoutStore.getDetails?.currentBp &&
        this.checkoutStore.getDetails?.desiredBp
      ) {
        return `${this.checkoutStore.getDetails?.currentBp} > ${this.checkoutStore.getDetails?.desiredBp}`;
      } else if (
        this.checkoutStore.getDetails?.numberOfWins &&
        !this.checkoutStore.getDetails?.difficultyTitle
      ) {
        return `${this.checkoutStore.getDetails?.numberOfWins} ${this.$t(
          "checkout.wins"
        )}`;
      } else if (this.checkoutStore.getDetails?.desiredHonour) {
        return ` ${this.$t("new.checkout.desiredHonour")}${
          this.checkoutStore.getDetails?.desiredHonour
        }`;
      } else if (this.checkoutStore.getDetails?.desiredConquest) {
        return ` ${this.$t("new.checkout.desiredConquest")}${
          this.checkoutStore.getDetails?.desiredConquest
        }`;
      } else if (
        this.checkoutStore.getDetails?.currentLevel &&
        this.checkoutStore.getDetails?.desiredLevel
      ) {
        return `${this.$t("new.checkout.current_level")} ${
          this.checkoutStore.getDetails?.currentLevel
        } > ${this.checkoutStore.getDetails?.desiredLevel} ${this.$t(
          "new.checkout.desired_level"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.currentMedals >= 0 &&
        this.checkoutStore.getDetails?.desiredMedals
      ) {
        return `${this.$t("current_medals")} ${
          this.checkoutStore.getDetails?.currentMedals
        } > ${this.checkoutStore.getDetails?.desiredMedals} ${this.$t(
          "desired_medals"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.currentTrophies >= 0 &&
        this.checkoutStore.getDetails?.desiredTrophies
      ) {
        return `${this.$t("current_trophies")} ${
          this.checkoutStore.getDetails?.currentTrophies
        } > ${this.checkoutStore.getDetails?.desiredTrophies} ${this.$t(
          "desired_trophies"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.currentRankPoints &&
        this.checkoutStore.getDetails?.desiredRankPoints
      ) {
        return `${this.$t("order_details.currentRankPoints")} ${
          this.checkoutStore.getDetails?.currentRankPoints
        } > ${this.checkoutStore.getDetails?.desiredRankPoints} ${this.$t(
          "order_details.desiredRankPoints"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.currentPrestigeLevel &&
        this.checkoutStore.getDetails?.desiredPrestigeLevel
      ) {
        // return `${this.$t("new.checkout.current_level")} ${
        //   this.checkoutStore.getDetails?.currentPrestigeLevel
        // } > ${this.checkoutStore.getDetails?.desiredPrestigeLevel} ${this.$t(
        //   "new.checkout.desired_level"
        // )}`;

        return `${this.checkoutStore.getDetails?.currentPrestigeTitle} > ${
          this.checkoutStore.getDetails?.desiredPrestigeTitle
        }
        <br/>
        ${this.$t("new.checkout.current_level")} ${
          this.checkoutStore.getDetails?.currentPrestigeLevel
        } > ${this.checkoutStore.getDetails?.desiredPrestigeLevel} ${this.$t(
          "new.checkout.desired_level"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.currentRating >= 0 &&
        this.checkoutStore.getDetails?.desiredRating
      ) {
        return `${this.$t("new.checkout.current_rating")} ${
          this.checkoutStore.getDetails?.currentRating
        } > ${this.checkoutStore.getDetails?.desiredRating} ${this.$t(
          "new.checkout.desired_rating"
        )}`;
      } else if (
        this.checkoutStore.getDetails?.desiredKeystone &&
        !this.checkoutStore.getDetails?.numberOfMythic
      ) {
        return `${this.$t("new.checkout.desired_keystone")}${
          this.checkoutStore.getDetails?.desiredKeystone
        }`;
      } else if (
        this.checkoutStore.getDetails?.numberOfMythic &&
        !this.checkoutStore.getDetails?.desiredKeystone
      ) {
        return ` ${this.$t("new.checkout.number_of_mythic")}${
          this.checkoutStore.getDetails?.numberOfMythic
        }`;
      } else if (
        this.checkoutStore.getDetails?.numberOfMythic &&
        this.checkoutStore.getDetails?.desiredKeystone
      ) {
        return `${this.$t("new.checkout.desired_keystone")}${
          this.checkoutStore.getDetails?.desiredKeystone
        } <br /> ${this.$t("new.checkout.number_of_mythic")}${
          this.checkoutStore.getDetails?.numberOfMythic
        }`;
      } else if (this.checkoutStore.getDetails?.numberOfGold) {
        return ` ${this.$t("new.checkout.number_of_gold")}${
          this.checkoutStore.getDetails?.numberOfGold
        }`;
      } else if (
        this.checkoutStore.getDetails?.difficultyTitle &&
        !this.checkoutStore.getDetails?.numberOfWins
      ) {
        return ` ${this.$t("new.checkout.difficulty")} ${
          this.checkoutStore.getDetails?.difficultyTitle
        }`;
      } else if (
        this.checkoutStore.getDetails?.mode &&
        this.checkoutStore.getDetails?.numberOfChallenges
      ) {
        return `<div class='d-flex-column justify-start align-start gap-5'>
          
          <div class='d-flex-row space-between height-max-content'>
          ${this.$t("challenge_type")} <span class='t-white f-w-600'>${
          this.checkoutStore.getDetails?.mode
        }</span>
          </div>
          <div class='d-flex-row space-between height-max-content'>
          ${this.$t("number_of_challenges")} <span class='t-white f-w-600'>${
          this.checkoutStore.getDetails?.numberOfChallenges
        }</span>
          </div>
          
          </div>`;
      } else if (this.checkoutStore.getDetails?.numberOfOrbs) {
        return `${this.$t("calculators_common.number_of_orbs")}(x${
          this.checkoutStore.getDetails?.numberOfOrbs
        })`;
      } else if (
        this.checkoutStore.getDetails?.currentRankTitle &&
        this.checkoutStore.getDetails.currentRank
      ) {
        return `${this.$t(
          "calculators_common.current_rank"
        )} <span class='t-white'>${
          this.checkoutStore.getDetails?.currentRankTitle
        }</span>`;
      } else if (this.checkoutStore.getDetails?.numberOfRivalPoints) {
        return `${this.$t("fc-boost.rival_points")} (x${
          this.checkoutStore.getDetails?.numberOfRivalPoints
        })`;
      } else if (
        this.checkoutStore.getDetails?.desiredRank?.id &&
        this.checkoutStore.getDetails?.desiredRank?.title
      ) {
        return `<div class='d-flex-row space-between height-max-content'>
          ${this.$t(
            "calculators_common.desired_rank"
          )} <span class='t-white f-w-600'>${
          this.checkoutStore.getDetails?.desiredRank?.title
        }</span>
          </div>`;
      }
      return "";
    },

    parsedSlabs() {
      const slabs = this.checkoutStore.getDetails?.optionSlabs || [];

      return this.getGamePack?.prices?.filter((price) =>
        slabs.includes(price.slab)
      );
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    const { getGamePack, getGameRanks } = useGameStore();
    const { getUserCurrencyCode } = useUserStore();
    return {
      checkoutStore,
      getGamePack,
      getGameRanks,
      getUserCurrencyCode,
    };
  },
};
</script>
